module.exports = __webpack_public_path__ + "static/media/WheatStage117.8cc5152b.PNG";